export default __webpack_public_path__ + "static/media/crmedway.73cf3bb2.svg";